import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const Navdata = () => {

  const [isComponents, setisComponents] = useState(false);

  function updateIconSidebar(e, currentId) {
    const ul = document.getElementById("two-column-menu");
    if (ul) {
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      iconItems.forEach((item) => {
        if (item.getAttribute("subitems") !== currentId) {
          item.classList.remove("active");
          const id = item.getAttribute("subitems");
          if (document.getElementById(id)) {
            document.getElementById(id).classList.remove("show");
          }
        }
      });
    }
  }

  const menuItems = [
    {
      id: "widgets",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      pkey: "Dashboard",
      parentId: "dashboard",
    },
    {
      id: "policy-upload",
      label: "Upload Documents",
      icon: "ri-upload-2-line",
      link: "/policy-upload",
      pkey: "PolicyUpload",
      parentId: "policy-upload",
    },
    {
      id: "action-settings",
      label: "Setting",
      icon: "ri-settings-3-line",
      link: "/settings-dashboard",
      pkey: "ActionSettings",
      parentId: "action-settings",
    },
  ];

  const dynamicmenuItems = menuItems;

  return <React.Fragment>{dynamicmenuItems}</React.Fragment>;
};
export default Navdata;
